import Contact from "../components/contact/contact"

export default Contact